/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Api_Method_Not_AllowedInputs */

const fr_api_method_not_allowed = /** @type {(inputs: Api_Method_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cette action n’est plus disponible. Actualisez la page.`)
};

const en_api_method_not_allowed = /** @type {(inputs: Api_Method_Not_AllowedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This action is no longer available. Refresh the page.`)
};

/**
* | output |
* | --- |
* | "This action is no longer available. Refresh the page." |
*
* @param {Api_Method_Not_AllowedInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const api_method_not_allowed = /** @type {((inputs?: Api_Method_Not_AllowedInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Api_Method_Not_AllowedInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_api_method_not_allowed(inputs)
	return fr_api_method_not_allowed(inputs)
});